import { erc20Abi, maxUint256 } from "viem";
import {
  useReadContract,
  useWaitForTransactionReceipt,
  useWriteContract,
} from "wagmi";

// 会员支付合约
const getMemberPaymentContract = () => {
  const env = process.env.NEXT_PUBLIC_ENV;
  switch (env) {
    case "dev":
      return "0x000000b60048e1E220bcaaBC2C6814bb98D593C8";
    case "beta":
      return "0x000000F0939129358Aa1775aD41bd0c9Db1EE983";
    case "pre":
      return "0x0000002972ffbD47f3458f9C6B7f5546CdAA732f";
    case "prod":
      return "0x0000005Fd572D37CE8618C01874a901f03Ca4679";
    default:
      return "0x000000F0939129358Aa1775aD41bd0c9Db1EE983";
  }
};

const contractAddress = getMemberPaymentContract() as `0x${string}`;

export const useContract = (
  address: `0x${string}`,
  tokenAddress: string,
  chainId: number,
) => {
  const {
    data: allowance,
    isLoading,
    error,
    refetch: refetchAllowance,
  } = useReadContract({
    address: tokenAddress as `0x${string}`,
    abi: erc20Abi,
    functionName: "allowance",
    args: [address as `0x${string}`, contractAddress],
    chainId: chainId,
  });
  const {
    data: approveHash,
    writeContract,
    isPending,
    error: approveError,
  } = useWriteContract();
  const { isLoading: isConfirming, isSuccess: isApprovedSuccess } =
    useWaitForTransactionReceipt({
      hash: approveHash,
    });
  const handleInfiniteApprove = () => {
    writeContract({
      address: tokenAddress as `0x${string}`,
      abi: erc20Abi,
      functionName: "approve",
      args: [contractAddress, maxUint256],
      chainId: chainId,
    });
  };

  return {
    allowance,
    isLoading,
    error,
    approveHash,
    isPending,
    approveError,
    isConfirming,
    handleInfiniteApprove,
    refetchAllowance,
    isApprovedSuccess,
  };
};
